// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"6d73e0d7","144":"80e30a4c","246":"80e30a4c","284":"06953570","308":"b93cde64","328":"f0cb6e03","374":"3de09e37","412":"06953570","589":"49179611","643":"6d73e0d7","747":"06953570","748":"6d73e0d7","840":"b61d3a45","895":"c5757077","981":"3de09e37"}[chunkId] + ".chunk.css";
};